// hnb-frontend/src/app/layout/PublicSiteLayout.tsx

import React from 'react';
import { Outlet } from 'react-router-dom';
import PublicHeader from '../../components/public/PublicHeader';
import PublicFooter from '../../components/public/PublicFooter';

export default function PublicSiteLayout() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background:
          'linear-gradient(180deg, #ffffff 0%, #fcfcfd 55%, #f8fafc 100%)',
        color: '#0f172a',
      }}
    >
      <PublicHeader />

      <main
        style={{
          flex: 1,
          width: '100%',
        }}
      >
        <Outlet />
      </main>

      <PublicFooter />
    </div>
  );
}